import React from "react";
import { UserDetailsRequirement } from "types";
import { PopoverListChoice } from "../Questionnaire/PopoverListChoice";
import { ContentLayout } from "@/components/Layout/ContentLayout";

type Props = {
    customerNamePreference: UserDetailsRequirement;
    onChange: (value: UserDetailsRequirement) => void;
    layout?: "section" | "stacked";
};

type PreferenceSelectorProps = {
    customerNamePreference: UserDetailsRequirement;
    onChange: (value: UserDetailsRequirement) => void;
};

interface UserDetailsRequirementSelectorProps {
    label: string;
    value: UserDetailsRequirement;
    onChange: (value: UserDetailsRequirement) => void;
    testId?: string;
}

export const UserDetailsRequirementSelector = ({
    label,
    value,
    onChange,
    testId,
}: UserDetailsRequirementSelectorProps) => {
    const handleChange = (option: string) => {
        const entry = Object.entries(UserDetailsRequirementLabels).find(([, optionLabel]) => optionLabel === option);
        if (entry) {
            onChange(entry[0] as UserDetailsRequirement);
        }
    };

    return (
        <div className="flex whitespace-nowrap" data-testid={testId}>
            {label}
            <div className="px-2">
                <PopoverListChoice
                    className="w-56"
                    values={Object.values(UserDetailsRequirementLabels)}
                    value={UserDetailsRequirementLabels[value]}
                    onChange={handleChange}
                />
            </div>
            for back office purchase
        </div>
    );
};

const PreferenceSelector = ({ customerNamePreference, onChange }: PreferenceSelectorProps) => (
    <UserDetailsRequirementSelector
        label="Purchaser name is"
        value={customerNamePreference}
        testId="product-questionnaire-purchaser"
        onChange={onChange}
    />
);

const StackedPurchaserSection = (props: PreferenceSelectorProps) => (
    <div className="space-y-2">
        <h6 className="font-bold">Purchaser Name</h6>
        <PreferenceSelector {...props} />
    </div>
);

const SectionPurchaserSection = (props: PreferenceSelectorProps) => (
    <ContentLayout.Section title="Purchaser">
        <div className="space-x-2 font-bold">
            <span>Name</span>
        </div>
        <PreferenceSelector {...props} />
    </ContentLayout.Section>
);

export const PurchaserInformationSection = ({ customerNamePreference, onChange, layout = "section" }: Props) => {
    const preferenceSelectorProps = { customerNamePreference, onChange };

    return layout === "stacked" ? (
        <StackedPurchaserSection {...preferenceSelectorProps} />
    ) : (
        <SectionPurchaserSection {...preferenceSelectorProps} />
    );
};

const UserDetailsRequirementLabels: Record<UserDetailsRequirement, string> = {
    [UserDetailsRequirement.REQUIRED]: "Required",
    [UserDetailsRequirement.OPTIONAL_CONFIRMATION]: "Optional (with confirmation)",
    [UserDetailsRequirement.OPTIONAL_NO_CONFIRMATION]: "Optional (no confirmation)",
    [UserDetailsRequirement.NOT_COLLECTED]: "Not Collected",
};
